export const ETypeOfCharge = {
  Weight: 0,

  FixedValue: 1,
} as const

export type ETypeOfCharge = (typeof ETypeOfCharge)[keyof typeof ETypeOfCharge]
